export default __webpack_public_path__ + "assets/580b2619aaaa962d2fe3d9714de50cf7.jpg";